import { DataView } from 'primereact/dataview';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import EventDetail from './EventDetail';
import EventItem from './EventItem';
import EventManager from './EventManager';

function EventPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { openQBEventDetail, navigationContext } = useNavigationContext();
  const [eventList, setEventList] = useState([]);
  const [eventDetail, setEventDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState(undefined);
  const [showpastEventList, setShowPastEventList] = useState(false);
  const [duplicationMode, setDuplicationMode] = useState(false);
  const [thematicFilter, setThematicFilter] = useState(undefined);
  const [highlightList, setHighlightList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);

  useEffect(() => {
    fetchEventList();
  }, [typeFilter, showpastEventList, thematicFilter]);

  const fetchEventList = async () => {
    await privateFetch(
      'GET',
      'quatrebis',
      `/cu/${accountContext.id}/event/?date=${showpastEventList && 'past'}&type=${typeFilter || ''}&thematic=${thematicFilter || ''}`
    ).then((res) => {
      setEventList(res);
    });
  };

  useEffect(() => {
    fetchEventList();
  }, [navigationContext]);

  const fetchPropertyList = async () => {
    await privateFetch(
      'GET',
      'resources',
      `/cu/${accountContext.id}/property/?types=qb_thematique`
    ).then((res) => {
      if (res) setPropertyList(res);
    });
  };

  useEffect(() => {
    fetchEventList();
    fetchPropertyList();
  }, []);

  const fetchEventDetail = async () => {
    await privateFetch(
      'GET',
      'quatrebis',
      `/cu/${accountContext.id}/event/${navigationContext.acitveEventId}/`
    ).then((res) => {
      if (res) setEventDetail(res);
    });
  };

  const handleClickEvent = (event) => {
    openQBEventDetail(event);
  };

  useEffect(() => {
    if (panelIsOpen === false) {
      setDuplicationMode(false) && setEventDetail(undefined);
    }
  }, [panelIsOpen]);

  const handleDuplicateEvent = (event) => {
    handleOpenManager();
    setDuplicationMode(true);
    handleClickEvent(event);
  };

  useEffect(() => {
    if (navigationContext.acitveEventId) {
      fetchEventDetail();
    } else setEventDetail(undefined);
  }, [navigationContext]);

  const goBackEventAction = {
    onClick: handleClickEvent,
    label: 'Retour à la liste',
    icon: 'pi pi-arrow-left'
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newEventAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un évènement',
    icon: 'pi-plus'
  };

  const createEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'quatrebis',
      `/cu/${accountContext.id}/event/`,
      "L'évènement a bien été ajouté",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      setLoading(false);
      setDuplicationMode(false);
      setEventDetail(undefined);
    });
  };

  const updateEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'quatrebis',
      `/cu/${accountContext.id}/event/${eventDetail.id}/`,
      "L'évènement a bien été modifié",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      fetchEventDetail(eventDetail.id);
      setLoading(false);
    });
  };

  const deleteEvent = async (event) => {
    await privateFetch(
      'DELETE',
      'quatrebis',
      `/cu/${accountContext.id}/event/${event.id}/`,
      "L'évènement a bien été supprimé"
    ).then(() => {
      fetchEventList();
      setEventDetail(undefined);
    });
  };

  const fetchHighlightList = async () => {
    await privateFetch(
      'GET',
      'quatrebis',
      `/cu/${accountContext.id}/highlight/?type=highlight`
    ).then((res) => {
      setHighlightList(res);
    });
  };

  useEffect(() => {
    fetchHighlightList();
  }, []);

  const itemTemplate = (event) => (
    <EventItem
      event={event}
      handleClickEvent={() => handleClickEvent(event)}
      handleDuplicateEvent={() => handleDuplicateEvent(event)}
    />
  );

  const eventFilters = (
    <div className="flex flex-row flex-wrap gap-2 justify-start">
      <div className="flex flex-row flex-wrap gap-2 ">
        <div className="fit-content mb-4">
          <SelectButton
            value={showpastEventList}
            onChange={(e) => setShowPastEventList(e.value)}
            options={CONSTANT.quatrebis.selectButtonOptions}
            className="rounded-full"
          />
        </div>
        <div className="fit-content mb-4">
          <Dropdown
            value={typeFilter}
            options={CONSTANT.quatrebis.type}
            optionLabel="label"
            onChange={(e) => setTypeFilter(e.value)}
            placeholder="Filtrer par Type"
            className="grow rounded-full pl-2"
            filter
            showClear
          />
        </div>
        <div className="fit-content mb-4">
          <Dropdown
            value={thematicFilter}
            options={propertyList}
            optionLabel="label"
            optionValue="id"
            onChange={(e) => setThematicFilter(e.value)}
            placeholder="Filtrer par Thématique"
            className="grow rounded-full pl-2"
            filter
            showClear
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Événements"
        labelAction={handleClickEvent}
        action={eventDetail ? goBackEventAction : newEventAction}
        detail={eventDetail}>
        {eventDetail && !duplicationMode ? (
          <EventDetail
            event={eventDetail}
            handleUpdateEvent={handleOpenManager}
            handleDelete={deleteEvent}
          />
        ) : (
          <>
            {eventFilters}
            <DataView
              value={eventList}
              itemTemplate={itemTemplate}
              className="pb-20"
              emptyMessage="Aucun évènement trouvé"
            />
          </>
        )}
      </PageWrapper>
      <EventManager
        isOpen={panelIsOpen}
        onClose={() => {
          setDuplicationMode(false);
          setPanelIsOpen(false);
        }}
        event={eventDetail}
        onCreate={createEvent}
        onUpdate={updateEvent}
        loading={loading}
        duplicationMode={duplicationMode}
        setPanelIsOpen={setPanelIsOpen}
        setEventDetail={setEventDetail}
        highlightList={highlightList}
      />
    </div>
  );
}

export default EventPage;
